import { SelectOption } from '@navstation-portal/shared/data-model/common';

export const OIL_CODE_OPTIONS: SelectOption[] = [
  { name: 'Normal Operation', code: 1 },
  { name: 'Running In', code: 2 },
  { name: 'Damaged Liner', code: 3 },
  { name: 'Units Cut Off', code: 4 },
] as const;
